import { useCallback } from 'react';

import { useAppDispatch } from '@/redux/hooks';
import { submitRecentSearch } from '@/redux/modules/saveSearch';
import { useSearchInputRedesignExperiment } from '@/utils/amplitude/experiments/hooks/useSearchInputRedesignExperiment.experiment';
import { getSearchUrlWithParams } from '@/utils/urls';

export const useSubmitRecentSearch = () => {
    const dispatch = useAppDispatch();
    const { isShowingFeature: hasSearchInputRedesignExperiment } = useSearchInputRedesignExperiment({ expose: false });

    return useCallback(
        (keyword: string) => {
            const cleanedKeyword = keyword.trim();

            if (!hasSearchInputRedesignExperiment || !cleanedKeyword) {
                return;
            }

            dispatch(
                submitRecentSearch({
                    saveSearchParams: { keyword: cleanedKeyword },
                    url: getSearchUrlWithParams({ keyword: cleanedKeyword }),
                })
            );
        },
        [dispatch, hasSearchInputRedesignExperiment]
    );
};
